import profile from "../assets/new_onboarding/profile.png";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ProfilePopUp() {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("name");

  useEffect(()=>{
        const userEmail = localStorage.getItem('userEmail');
        if(userEmail){
            setUserEmail(userEmail)
        }
    }, [])

  const handleLogOut = async () => {
    console.log("log out clicked");
    try {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("developer_id");
      localStorage.removeItem("user_id");
      localStorage.removeItem("profile_id");

      // 3. Redirect to login
      navigate("/interactive/login");
    } catch (error) {
      console.error("Logout failed:", error.response?.data || error.message);
    }
  };

  return (
    <div className="bg-[#FFECAE] w-screen p-8 h-56 rounded-md">
      <div
        className="text-left text-xl text-[#3F4C7C]"
        style={{ fontFamily: "GothamRounded" }}
      >
        {/* your profile */}
        Your profile
      </div>
      {/* profile card */}
      <div className="flex bg-[#FBD446] p-2 rounded-2xl">
        <div className="pr-2 ">
          <img
            src={profile}
            alt="profile image"
            className="object-contain bg-[#3F4C7C] rounded-full p-2"
          />
        </div>
        <div className="flex-col text-left">
          <div
            className="text-[#3F4C7C] text-lg"
            style={{ fontFamily: "GothamRounded" }}
          >
            {userEmail}
          </div>
          <div className="" style={{ fontFamily: "Lato" }}>
            Edit
          </div>
        </div>
      </div>
      {/* log out button */}
      <button
        className="rounded-2xl bg-[#3F4C7C] text-[white] p-4 m-3"
        style={{ fontFamily: "GothamRounded" }}
        onClick={handleLogOut}
      >
        Log out
      </button>
    </div>
  );
}
